import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ListLayout, ListLayoutMultipleComponent } from 'gung-list';
import { first, forkJoin, map, mergeMap, of } from 'rxjs';
import { QuotesTableComponent } from '../../components/quotes-table/quotes-table.component';
import { Order } from '../../models/order';
import { CustomerService } from '../customers/customer.service';
import { MetadataService } from '../metadata/metadata.service';
import { OrderListConfigService } from '../order-list-config/order-list-config.service';

@Injectable({
  providedIn: 'root'
})
export class QuotesConfigService extends OrderListConfigService {
  protected translationService = inject(TranslateService);
  protected metadataService = inject(MetadataService);
  protected customerService = inject(CustomerService);

  getLayouts(): ListLayout<Order>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => QuotesTableComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'Order list'
      }
    ];
  }

  getItems() {
    return this.orderService.getQuotes().pipe(
      mergeMap(items => forkJoin([of(items), this.customerService.getCustomers().pipe(first())])),
      map(([orders, customers]) => {
        const result = orders.map(order => {
          return {
            ...order,
            extra: {
              ...order.extra
            }
          };
        });
        result.map(resOrder => {
          const cust = customers.find(customer => customer.id === resOrder.deliveryCustomerId);
          resOrder.extra.customerName = cust ? cust.name : '';
          return resOrder;
        });

        const sorted = result.sort((a, b) => {
          if (a.extra.oh.orddatum > b.extra.oh.orddatum) {
            return 1;
          }
          if (a.extra.oh.orddatum < b.extra.oh.orddatum) {
            return -1;
          }
          return 0;
        });

        return sorted.reverse();
      })
    );
  }
}
